import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import './style.css'; 
let problemVaidation=(props)=> { 
  return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  
  Problem Validation ScoreCard
  </h4>
        <br></br>
        <h6 id="h62">Problem validation is a research based activity. You fill this scorecard after you conduct customer research</h6>
        <h6 id="h6">
  For a first pasa evaluation, you can attribute a score which is 1/2 of your first guess in each of the score below</h6>
        <h6 id="h6">
  For the second pass evaluation you would plug in actual research data. This is one the most important step</h6>
        <div id='divL'>
          <table id="tableAll">
            <thead>
              <tr>
                <th scope="col">Validation Topic</th>
                <th scope="col">Validation Below 30%</th>
                <th scope="col">Validation between
                  <br></br>30% to 50%</th>
                <th scope="col">Validation Above 50%</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Validation Topic">Problem Or Need</td>
                <td data-label="Validation Below 30%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation between 30% to 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation Above 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Validation Topic">Situation in Which Problem the problem is Experience</td>
                <td data-label="Validation Below 30%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation between 30% to 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation Above 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Validation Topic">Who in the situation is facing the problem?</td>
                <td data-label="Validation Below 30%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation between 30% to 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation Above 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Validation Topic">What is the Purposed Solution</td>
                <td data-label="Validation Below 30%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation between 30% to 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
                <td data-label="Validation Above 50%">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Validation Topic">Total</td>
                <td data-label="Validation Below 30%">
                  <input type='text' placeholder="Locked" id="lockedInput"></input>
                </td>
                <td data-label="Validation between 30% to 50%">
                  <input type='text' placeholder="Locked" id="lockedInput"></input>
                </td>
                <td data-label="Validation Above 50%">
                  <input type='text' placeholder="Locked" style={{padding:4,marginTop:10,borderRadius:4,borderColor: 'transparent',outline: 'none',color: '#666B6E',width:200, height: 45}}></input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/problemScorecard')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/solutionScorecard')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default problemVaidation;